/**
 * DiCon Incident Service API
 * API used by DiCon, LiOn and Buefo.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: dienstleistung@netze-bw.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AutomatedIncidentPostProcessingRuleTOV2 } from './automatedIncidentPostProcessingRuleTOV2';


/**
 * List of search results
 */
export interface ResultPageV2 { 
    /**
     * Total number of search results
     */
    totalCount?: number;
    /**
     * Configuration data for automated order creation and employee assignment
     */
    data?: Array<AutomatedIncidentPostProcessingRuleTOV2>;
}

